export default function forEach(array, callback) {
    let index = 0;
    for (const item of array) {
        const value = callback(item, index);
        if (value === false) {
            break;
        }
        index++;
    }
}
